import React from 'react';

import {Stack, ToggleButton, ToggleButtonGroup} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import {ArrowBack as ArrowBackIcon} from '@mui/icons-material';
import {useNavigate} from 'react-router-dom';

import {MonitorPanel} from '@wheeebo/polaris-cesium';
import {Head, CesiumMapProvider, MonitorMapProvider, RadarCard, RightDrawer, WeatherCard} from '@wheeebo/polaris-ui';

import VehicleListCard from '@components/pages/monitor/VehicleListCard';
import {config} from '@components/Constants';

function MonitorPage(): JSX.Element {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <CesiumMapProvider>
      <MonitorMapProvider>
        <Head title="Monitor (3D)" />
        <MonitorPanel env={config.ENVIRONMENT} />
        <ToggleButtonGroup
          color="primary"
          size="small"
          exclusive
          sx={{backgroundColor: theme.palette.background.paper, position: 'absolute'}}>
          <ToggleButton size="small" sx={{py: 2 / 5}} value="back" onClick={() => navigate('/monitor')}>
            <ArrowBackIcon fontSize="small" sx={{mr: 1}} />
            Back to Map
          </ToggleButton>
        </ToggleButtonGroup>
        <RightDrawer>
          <Stack gap={1 / 2}>
            <WeatherCard />
            <RadarCard />
            <VehicleListCard />
          </Stack>
        </RightDrawer>
      </MonitorMapProvider>
    </CesiumMapProvider>
  );
}

export default React.memo(MonitorPage);
